import * as React from "react"
import type { SVGProps } from "react"
const SvgSettingsTune = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14 9.86a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.43.29-.72a1 1 0 0 1 .71-.28h2v-3q0-.43.29-.72a1 1 0 0 1 .71-.28q.42 0 .71.29.3.28.29.7v3h2q.42 0 .71.3.3.28.29.7c-.01.43-.1.53-.29.72a1 1 0 0 1-.71.29zm3 12a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-8q0-.43.29-.72a1 1 0 0 1 .71-.28q.42 0 .71.28.3.3.29.72v8q0 .42-.29.71a1 1 0 0 1-.71.29m-10 0a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-3H4a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.43.29-.72a1 1 0 0 1 .71-.28h6q.42 0 .71.28.3.3.29.72 0 .42-.29.71a1 1 0 0 1-.71.29H8v3q0 .42-.29.71a1 1 0 0 1-.71.29m0-8a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-8q0-.43.29-.72A1 1 0 0 1 7 3.86q.42 0 .71.29.3.28.29.7v8q0 .44-.29.72a1 1 0 0 1-.71.29" />
  </svg>
)
export default SvgSettingsTune
